// extracted by mini-css-extract-plugin
export default {"anywhere":"ConfirmVote_anywhere__+l5yz","isDone":"ConfirmVote_isDone__NuAh1","submitBtn":"ConfirmVote_submitBtn__CYCOU"};